import { FieldPath, UseFormReturn } from 'react-hook-form';
import { ToggleField } from '@brighte/form-components';
import { HouseholdType, Period } from '@brighte/validation';
import { RepaymentField } from '@components/RepaymentField';
import { Stack } from '@spark-web/stack';
import { FinancialFieldTypes, HOUSEHOLD } from '@utils';

type Props = Pick<UseFormReturn<HouseholdType>, 'watch' | 'control' | 'setValue'>;

function OtherLoans({ control, watch, setValue }: Props) {
  const { OTHER_LOANS_LABEL, OTHER_LOANS_SUBTITLE } = HOUSEHOLD;

  const OTHER_LOANS_FIELD = 'applicant.expense.otherLoans' as FieldPath<HouseholdType>;

  const [isOtherLoansNotApplicable, applicantOtherLoansAmount, applicantOtherLoansPeriod] = watch([
    `${OTHER_LOANS_FIELD}.isNotApplicable`,
    `${OTHER_LOANS_FIELD}.amount`,
    `${OTHER_LOANS_FIELD}.period`,
  ]);

  const handleOtherLoansToggle = (value: boolean) => {
    // value is isNotApplicable: true = "No" (not applicable), false = "Yes" (has other loans)
    if (value) {
      setValue(`${OTHER_LOANS_FIELD}.amount` as FieldPath<HouseholdType>, 0);
      setValue(`${OTHER_LOANS_FIELD}.period` as FieldPath<HouseholdType>, Period.Monthly);
    }
  };

  return (
    <Stack gap="xxlarge">
      <ToggleField
        name={`${OTHER_LOANS_FIELD}.isNotApplicable` as FieldPath<HouseholdType>}
        label={OTHER_LOANS_LABEL}
        description={OTHER_LOANS_SUBTITLE}
        control={control}
        layout="inline"
        onChange={handleOtherLoansToggle}
        isInvertedValue
      />
      {!isOtherLoansNotApplicable && isOtherLoansNotApplicable !== undefined && (
        <RepaymentField
          control={control}
          periodFieldName={`${OTHER_LOANS_FIELD}.period` as FieldPath<HouseholdType>}
          amountFieldName={`${OTHER_LOANS_FIELD}.amount` as FieldPath<HouseholdType>}
          periodValue={applicantOtherLoansPeriod}
          amountValue={applicantOtherLoansAmount}
          heading="Other loans (repayment)"
          subheading="Enter the combined repayment amount for your other loans."
        />
      )}
    </Stack>
  );
}

export default OtherLoans;
